import * as actions from './actions';
import { CTA_EVENTS, trackEvent } from './../../tracking';

export const createUser = (payload) => (dispatch, getState) => {
  const currentUserOrganizationId = getState().user.get('organization').id;

  dispatch(trackEvent(CTA_EVENTS.ADD_USER_MODAL.SUBMIT));
  return dispatch(actions.createUser({
    organizationId: currentUserOrganizationId,
    ...payload,
  }));
};

export const createInvitation = (payload, source = 'team-management') => (dispatch, getState) => {
  const currentUserOrganizationId = getState().user.get('organization').id;

  dispatch(trackEvent(CTA_EVENTS.ADD_USER_MODAL.SUBMIT_INVITE, {
    source,
  }));
  return dispatch(actions.createInvitation({
    organizationId: currentUserOrganizationId,
    ...payload,
  }));
};
